<modal [name]="localStorageKeys.ti_modal_errors_grid" (closeOut)="onClose()" [style.height]="'auto'" [style.minWidth]="'auto'" [width]="showPostProcessButton ? 720 : 580">
  <modal-header><span>{{ title || strings.error }}</span></modal-header>
  <modal-body [style.height]="'auto'">
    <div *ngIf="comment" class="comment">
      <span class="icon fa"
            [ngClass]="title === strings.warning ? 'fa-exclamation-circle warning' : 'fa-exclamation-triangle error'"
      ></span>
      <div class="comment-text">{{ comment || '' }}</div>
    </div>
    <kendo-grid *ngIf="data"
      [data]="data"
      [resizable]="true"
      [selectable]="{checkboxOnly: true, mode: 'multiple'}"
      [kendoGridSelectBy]="showCheckboxes ? 'ObjectId' : 'ObjectName'"
      [selectedKeys]="selectedKeys"
    >
      <kendo-grid-checkbox-column
        *ngIf="showCheckboxes"
        class="ti-grid-cell"
        [resizable]="false"
        [reorderable]="false"
        [locked]="true"
        showSelectAll="true"
        [width]="30"></kendo-grid-checkbox-column>
      <kendo-grid-column *ngFor="let col of columns" [field]="col.name" [title]="col.title" [width]="col.width || 100" [headerStyle]="{'color': '#000000'}" [style]="{'white-space': 'normal'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="cell-content" [innerHTML]="dataItem[col.name]"></div>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </modal-body>
  <modal-actions>
    <button *ngIf="showPostProcessButton" [disabled]="processButtonDisabled" kendoButton (click)="onPostProcess()" [primary]="true">{{ processButtonTitle }}</button>
    <button kendoButton (click)="onClose()" [primary]="!showPostProcessButton">{{ closeButtonTitle }}</button>
  </modal-actions>
</modal>
